import { Link } from 'react-router-dom';
import { Typography, TableList } from 'seagull';
import { routes } from "../../../constants";
import { jsx as _jsx } from "react/jsx-runtime";
export const RemainingCreditRow = props => {
  const {
    data
  } = props;
  const items = [{
    value: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Typography, {
        as: Link,
        to: routes.agreement(data.relationshipId),
        testId: "remaining-credit-report-row-customer",
        variant: "paragraph1",
        noWrap: true,
        ellipsis: true,
        children: data.customerName
      })
    })
  }, {
    value: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Typography, {
        testId: "remaining-credit-report-row-agreement",
        variant: "paragraph1",
        noWrap: true,
        ellipsis: true,
        children: data.agreementName
      })
    })
  }, {
    value: /*#__PURE__*/_jsx(Typography, {
      testId: "remaining-credit-report-row-service",
      variant: "paragraph1",
      noWrap: true,
      ellipsis: true,
      children: data.serviceName
    })
  }, {
    value: /*#__PURE__*/_jsx(Typography, {
      testId: "remaining-credit-report-row-rate",
      variant: "paragraph1",
      noWrap: true,
      children: data.credit
    })
  }];
  return /*#__PURE__*/_jsx(TableList.Row, {
    items: items,
    rowId: props.index,
    testId: "remaining-credit-report-row-".concat(props.index),
    "data-heapid": "remaining-credit-report-row"
  });
};